<template>
  <section class="dbc-gl-section dbc-gl-section--no-p-top">
    <Registration
      :termsOfServiceUrl="content.termsOfServiceLandingpage"
      :privacyUrl="content.privacyLandingpage"
    ></Registration>
  </section>
</template>

<script setup lang="ts">
const props = defineProps<{
  content: ContentRegistration
}>()

provide('successLandingPage', props.content.successLandingpage || '')

useHead({
  script: [
    {
      src: useRuntimeConfig().public.nexi.script,
      type: 'text/javascript',
      tagPosition: 'bodyClose',
    },
    {
      src: useRuntimeConfig().public.nexi.bridgeJS,
      type: 'text/javascript',
      tagPosition: 'bodyClose',
    },
  ],
})
</script>
